import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { AlertService, BannersService, AppService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { appConfig } from "../app.config";
import { DataTableDirective } from "angular-datatables";

class Banners {
  id: number;
  name: string;
  position: string;
  image_path: string;
  is_link: string;
  link_url: string;
  start_date: string;
  end_date: string;
  is_active: string;
  mobile_image: string;
  sequence: string;
}

@Component({
  selector: "app-banners",
  templateUrl: "./banners.component.html",
})
export class BannersComponent implements OnInit {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {
    pagingType: "full_numbers",
    pageLength: 10,
    columnDefs: [{ targets: [9], orderable: false }],
  };
  dtTrigger = new Subject();
  isSubmitted = false;
  croppedImage: any = "";
  mobileCroppedImage: any = "";
  @Input() allowMultiple: boolean;
  @Input() fileType: string = ".jpg, .jpeg, .png, .bmp";

  @Input() required: boolean;
  @Input() maxSizeInKb: number;
  @Output() onSelection = new EventEmitter<FileList>();
  DisplayedText: string = "";
  DisplayedText2: string = "";
  fileList: any;
  mobileFileList: any;
  pdf = false;
  exl = false;
  bannersList: Banners[] = [];
  desktopImgErr: any;
  mobileImgErr: any;
  getBanners = {
    id: "",
    name: "",
    position: "TOP",
    image_path: "",
    is_link: "",
    link_url: "",
    start_date: "",
    end_date: "",
    is_active: "",
    mobile_image: "",
    sequence: "",
  };
  closeResult: string; // Modal Close

  constructor(
    public router: Router,
    private dataService: BannersService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal
  ) {}

  banners = {
    id: "",
    name: "",
    position: "TOP",
    image_path: "",
    is_link: "",
    link_url: "",
    start_date: "",
    end_date: "",
    is_active: "",
    mobile_image: "",
    sequence: "",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;
  showloding = true;
  lodingImage = false;
  positionChecked: string;

  ngOnInit() {
    window.scroll(0, 0);

    this.allBanners();
  }

  // allBanners() {
  //   this.loadShow();
  //   this.dataService
  //     .getAllBanners()
  //     .pipe()
  //     .subscribe((data) => {
  //       this.bannersList = data["banners"];
  //       this.pdf = true;
  //       this.exl = true;
  //       this.rerender();
  //       this.loadHide();
  //     });
  // }

  allBanners() {
    this.loadShow();
    this.dataService
      .getAllBanners()
      .pipe()
      .subscribe((data) => {
        this.bannersList = data["banners"] || [];

        this.bannersList.sort((a, b) => {
          return Number(a.sequence) - Number(b.sequence);
        });

        this.pdf = true;
        this.exl = true;
        this.rerender();
        this.loadHide();
      });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  open(content) {
    this.croppedImage = "";
    this.mobileCroppedImage = "";
    this.desktopImgErr = "";
    this.mobileImgErr = "";
    this.isSubmitted = false;
    if (this.getBanners.id != null) {
      this.getBanners.id = "";
    }
    this.banners.id = "";
    this.banners.name = "";
    this.banners.position = "TOP";
    this.banners.image_path = "";
    this.banners.is_link = "";
    this.banners.link_url = "";
    this.banners.start_date = "";
    this.banners.end_date = "";
    this.banners.mobile_image = "";
    this.banners.is_active = "Y";
    this.banners.sequence = "";
    this.DisplayedText = "";
    this.DisplayedText2 = "";
    this.modalTitle = "Add Banners";

    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  save(val, f) {
    this.isSubmitted = true;
    this.mobileImgErr = "";
    this.desktopImgErr = "";

    if (!val.id) {
      if (!this.banners.image_path || this.banners.image_path.trim() === "") {
        this.desktopImgErr = "Desktop image is required";
        return;
      }

      if (
        !this.banners.mobile_image ||
        this.banners.mobile_image.trim() === ""
      ) {
        this.mobileImgErr = "Mobile image is required";
        return;
      }
    }
    if (f.form.valid) {
      this.loadShow();
      this.insertAction(val);
    } else {
      document.querySelector(".modal").scrollTo({ top: 0, behavior: "smooth" });
    }
  }

  edit(id, content) {
    this.loadShow();
    this.DisplayedText = "";
    this.DisplayedText2 = "";
    this.dataService.getBanners(id).subscribe((data) => {
      this.getBanners = data["banners"];
      this.getBanners.position = "TOP";

      this.croppedImage = this.getBanners.image_path || "";
      this.mobileCroppedImage = this.getBanners.mobile_image || "";

      if (this.getBanners.sequence == "null") {
        this.getBanners.sequence = "";
      }

      this.banners = {
        id: this.getBanners.id,
        name: this.getBanners.name,
        position: this.getBanners.position,
        image_path: this.getBanners.image_path,
        is_link: this.getBanners.is_link,
        link_url: this.getBanners.link_url,
        start_date: this.getBanners.start_date,
        end_date: this.getBanners.end_date,
        is_active: this.getBanners.is_active,
        mobile_image: this.getBanners.mobile_image,
        sequence: this.getBanners.sequence,
      };

      this.loadHide();
      this.modalTitle = "Edit Banners";
      this.modalReference = this.modalService.open(content, {
        backdrop: "static",
        keyboard: false,
      });
    });
  }

  preventPaste(event: ClipboardEvent) {
    const pastedInput: string = event.clipboardData.getData("text") || "";
    if (!/^\d+$/.test(pastedInput)) {
      event.preventDefault();
    }
  }

  preventEKey(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  onFileChange(event: any) {
    this.fileList = event.target.files;
    let hasFile = this.fileList && this.fileList.length > 0;
    this.DisplayedText = hasFile ? this.fileList[0].name : "";

    if (hasFile) {
      const extension = this.fileList[0].name
        .substring(this.fileList[0].name.lastIndexOf("."))
        .toLowerCase();
      const validFileType = [".jpg", ".jpeg", ".png", ".bmp"];
      if (!validFileType.includes(extension)) {
        alert(
          "Please select a valid file type. Supported file types are .jpg, .jpeg, .png, .bmp"
        );
        this.resetFileInput(event);
        return false;
      }

      if (this.fileList[0].size > 5000000) {
        alert(`File size is more than 5 MB`);
        this.resetFileInput(event);
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(this.fileList[0]);

      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          if (img.width < 1400 || img.height < 428) {
            this.desktopImgErr =
              "Image should be at least 1400 x 428 pixels (or larger with the same ratio)";
            this.resetFileInput(event);
            return;
          }

          this.desktopImgErr = "";
          this.croppedImage = reader.result as string;
          this.banners.image_path = this.croppedImage;
        };
      };
    }
    return false;
  }

  // ✅ Helper to reset file input and preview
  resetFileInput(event: any) {
    this.fileList = null;
    this.DisplayedText = "";
    this.croppedImage = "";
    if (event && event.target) {
      event.target.value = "";
    }
  }

  mobileImageChange(event: any) {
    this.mobileFileList = event.target.files;
    this.DisplayedText2 =
      this.mobileFileList && this.mobileFileList.length > 0
        ? this.mobileFileList[0].name
        : "";

    let hasFile = this.mobileFileList && this.mobileFileList.length > 0;
    if (hasFile) {
      const extension = this.mobileFileList[0].name
        .substring(this.mobileFileList[0].name.lastIndexOf("."))
        .toLowerCase();

      const validFileType = [".jpg", ".jpeg", ".png", ".bmp"];
      if (!validFileType.includes(extension)) {
        this.mobileImgErr =
          "Please select a valid file type. Supported: .jpg, .jpeg, .png, .bmp";
        this.resetMobileInput(event);
        return false;
      }

      // ✅ File size check (max 5 MB)
      if (this.mobileFileList[0].size > 5000000) {
        this.mobileImgErr = "File size is more than 5 MB";
        this.resetMobileInput(event);
        return false;
      }

      const reader = new FileReader();
      reader.readAsDataURL(this.mobileFileList[0]);
      reader.onload = () => {
        const img = new Image();
        img.src = reader.result as string;

        img.onload = () => {
          // ✅ Check minimum dimensions
          if (img.width < 700 || img.height < 947) {
            this.mobileImgErr =
              "Image should be at least 700 x 947 pixels (or larger with the same ratio)";
            this.resetMobileInput(event);
            return;
          }

          // ✅ All good → set preview
          this.mobileImgErr = "";
          this.mobileCroppedImage = reader.result as string;
          this.banners.mobile_image = this.mobileCroppedImage;
        };
      };
    }
    return false;
  }

  // ✅ Helper to reset input
  resetMobileInput(event: any) {
    this.mobileFileList = null;
    this.DisplayedText2 = "";
    this.mobileCroppedImage = "";
    if (event && event.target) {
      event.target.value = "";
    }
  }

  insertAction(val) {
    let formData: FormData = new FormData();

    formData.append("name", this.banners.name);
    formData.append("position", this.banners.position);
    formData.append("is_link", this.banners.is_link);
    formData.append("link_url", this.banners.link_url);
    formData.append("start_date", this.banners.start_date);
    formData.append("end_date", this.banners.end_date);
    formData.append("is_active", this.banners.is_active);
    formData.append("sequence", this.banners.sequence);

    if (val.id == "") {
      if (this.fileList) {
        formData.append("image_path", this.croppedImage);
      }
      if (this.mobileFileList) {
        formData.append("mobile_image", this.mobileCroppedImage);
      }
      this.dataService
        .save(formData)
        .pipe()
        .subscribe(
          (data) => {
            if (data["status"] == 200) {
              this.alertService.success("Banners created successfully", true);
              this.modalReference.close();
              this.allBanners();
            } else if (data["status"] == 422) {
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
              this.alertService.error(data.mesg);
              this.loadHide();
            } else {
              this.alertService.error(data.message);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
              this.loadHide();
            }
          },
          (error) => {
            this.alertService.error(error);
          }
        );
    } else {
      formData.append("id", val.id);

      if (this.isBase64(this.banners.image_path)) {
        formData.append("image_path", this.banners.image_path);
      } else {
        formData.append("image_path", ""); // not base64 → send blank
      }

      if (this.isBase64(this.banners.mobile_image)) {
        formData.append("mobile_image", this.banners.mobile_image);
      } else {
        formData.append("mobile_image", ""); // not base64 → send blank
      }

      this.dataService
        .bannersUpdate(formData)
        .pipe()
        .subscribe(
          (data) => {
            if (data["status"] == 200) {
              this.alertService.success("Banners updated successfully", true);
              this.modalReference.close();
              this.allBanners();
            } else if (data["status"] == 422) {
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
              this.alertService.error(data.mesg);
            }
            this.loadHide();
          },
          (error) => {
            this.alertService.error(error);
            document
              .querySelector(".modal")
              .scrollTo({ top: 0, behavior: "smooth" });
          }
        );
    }
  }

  isBase64(str: string): boolean {
    return str.startsWith("data:image");
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .bannersDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("Banners deleted successfully", true);
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            this.allBanners();
          } else {
            this.alertService.error("Banners error");
          }
        },
        (error) => {
          this.alertService.error(error);
        }
      );
    this.loadHide();
  }

  pdfExport() {
    window.open(appConfig.apiUrl + "/api/blog-list-pdf", "_blank");
  }

  xlExport() {
    window.open(appConfig.apiUrl + "/api/blog-list-excel", "_blank");
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
